/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface HhFieldFilterDto
 */
export interface HhFieldFilterDto {
  /**
   *
   * @type {string}
   * @memberof HhFieldFilterDto
   */
  field: HhFieldFilterDtoFieldEnum;
  /**
   *
   * @type {string}
   * @memberof HhFieldFilterDto
   */
  mode: HhFieldFilterDtoModeEnum;
  /**
   *
   * @type {string}
   * @memberof HhFieldFilterDto
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof HhFieldFilterDto
   */
  value2: string;
}

export const HhFieldFilterDtoFieldEnum = {
  Room: "ROOM",
  Date: "DATE",
  Pid: "PID",
  StartTime: "START_TIME",
  Profile: "PROFILE",
  Tournament: "TOURNAMENT",
  BuyinUsd: "BUYIN_USD",
  GameType: "GAME_TYPE",
} as const;

export type HhFieldFilterDtoFieldEnum =
  (typeof HhFieldFilterDtoFieldEnum)[keyof typeof HhFieldFilterDtoFieldEnum];
export const HhFieldFilterDtoModeEnum = {
  Contains: "CONTAINS",
  StartsWith: "STARTS_WITH",
  EndsWith: "ENDS_WITH",
  Equals: "EQUALS",
  NotEquals: "NOT_EQUALS",
  Between: "BETWEEN",
  Empty: "EMPTY",
  NotEmpty: "NOT_EMPTY",
} as const;

export type HhFieldFilterDtoModeEnum =
  (typeof HhFieldFilterDtoModeEnum)[keyof typeof HhFieldFilterDtoModeEnum];
